import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption } from '@elastic/eui';
import { GEAR_TYPES } from 'apollo-client/queries/getAvailableGearTypes';
import { Query, QueryGetAvailableGearTypesArgs } from 'generated/graphql';
import { useIntl } from 'react-intl';
import { gearTypes } from 'cache';
import { useLocalCache } from 'hooks/useLocalCache';

import * as S from './FiltersSidebar.styles';

export const GearTypeFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [onGetAvailablegearType, { loading, data }] = useLazyQuery<Query, QueryGetAvailableGearTypesArgs>(GEAR_TYPES);

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.gearType.label' })}</EuiFormLabel>
      <EuiComboBox
        async
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.gearType.placeholder' })}
        options={data?.getAvailableGearTypes?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={localFilters?.data?.gearTypes?.map((x: string) => ({ label: x, value: x }))}
        onSearchChange={(e: string): void => {
          onGetAvailablegearType({ variables: { inputGearType: e } });
        }}
        onClick={(): void => {
          onGetAvailablegearType({ variables: { inputGearType: '' } });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): string[] | undefined =>
          gearTypes(x?.map(({ value }) => value) as string[])
        }
      />
    </S.SidebarFilterWrapper>
  );
};
